/** @file toolRepressed: whether a store update was the current tool's key pressed again (a no-op setTool). */
import type { EditorState, Tool } from '../../state/editorTypes';

/** The key code of a chord (`Shift+KeyW` -> `KeyW`). */
const codeOf = (chord: string): string => chord.split('+').at(-1) ?? chord;

/**
 * True when `next` is a new state object equal to `prev` field by field (a `set` that changed nothing, as
 * `setTool(tool)` with the current tool makes) while the tool's key (`chordOf(tool)`, overrides applied) is held:
 * the user pressed the current tool's key again and should see it acknowledged, not a dead key.
 */
export function toolRepressed(next: EditorState, prev: EditorState, chordOf: (tool: Tool) => string | undefined, held: (code: string) => boolean): boolean {
  if (next === prev || next.tool !== prev.tool) return false;
  const chord = chordOf(next.tool);
  if (chord === undefined || !held(codeOf(chord))) return false;
  return (Object.keys(next) as (keyof EditorState)[]).every((k) => next[k] === prev[k]);
}
